import { render, staticRenderFns } from "./flagViewOnly.vue?vue&type=template&id=3168205e&scoped=true"
import script from "./flagViewOnly.vue?vue&type=script&lang=js"
export * from "./flagViewOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168205e",
  null
  
)

export default component.exports